import React from 'react';

/**
 * StatChip — displays an axis score with its icon + colour.
 * Used on clip cards to surface Hook / Emotion / Virality / Retention at a glance.
 *
 * Value semantics: 0..100 → colour intensity fades naturally via the
 * `score` prop. No animation on the number here (parent decides).
 */
const AXIS_COLORS = {
  viral:     '#D4FF00',
  hook:      '#F59E0B',
  retention: '#22C55E',
  emotion:   '#A855F7',
};

const StatChip = ({ label, value, axis = 'viral', suffix = '', testid }) => {
  const color = AXIS_COLORS[axis] || AXIS_COLORS.viral;
  const has = typeof value === 'number';
  return (
    <div
      className="flex items-center gap-1.5 px-2 py-1 rounded-md border text-[10px] font-mono uppercase tracking-wider tabular-nums"
      style={{
        borderColor: has ? `${color}40` : '#ffffff10',
        backgroundColor: has ? `${color}0d` : 'transparent',
        color: has ? color : '#71717a',
      }}
      data-testid={testid}
    >
      <span>{label}</span>
      <span className="font-bold">{has ? `${Math.round(value)}${suffix}` : '—'}</span>
    </div>
  );
};

export default StatChip;
